import template from './address.html';
import { actions, selectors } from '../../../state';

const SIGN_UP_ERROR_MESSAGE =
  'Looks like there was a problem. Reach out to help@updater.com for help signing up.';

class GetStartedAddressController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    const { connect, getState } = this.updStore;
    this.disconnect = connect(mapStateToThis)(this);

    // Not using `connect` here since we're attaching this to a form
    const state = getState();
    this.move = {
      from_address: selectors.signUp.fromAddress(state),
      to_address: selectors.signUp.toAddress(state),
    };
  }

  $onDestroy() {
    this.disconnect();
  }

  onAddressChange(property, address) {
    this.move = {
      ...this.move,
      [property]: address,
    };
    this.updStore.dispatch(actions.signUp.setAddresses(this.move));
  }

  submit(data) {
    const { dispatch } = this.updStore;

    const error = () => {
      dispatch(actions.message.error(SIGN_UP_ERROR_MESSAGE));
    };

    const success = () => {
      dispatch(actions.router.stateGo(this.next));
      dispatch(actions.analytics.track(this.successEvent));
    };

    dispatch(actions.session.signUp(this.currentSignUp)).then(success, error);
  }
}

export const GetStartedAddressComponent = {
  template,
  controller: GetStartedAddressController,
};

function mapStateToThis(state) {
  return {
    prev: selectors.router.currentDataProp('prev', state),
    next: selectors.router.currentDataProp('next', state),
    successEvent: selectors.router.currentAnalyticsProp('success', state),
    submitting: selectors.pending.match(actions.session.isSignUp, state),
    currentSignUp: selectors.signUp.current(state),
  };
}
